<template>
  <div class="component-container">
    <div class="title-table">
      <div class="tab-item">时间</div>
      <div class="tab-item">城市</div>
      <div class="tab-item">IP</div>
      <div class="tab-item">登录设备</div>
    </div>
    <div v-for="(item, index) in listData" :key="index" class="list-box">
      <div class="list-item">{{ item.addTime }}</div>
      <div class="list-item">{{ item.cityName }}</div>
      <div class="list-item">{{ item.ipAddress }}</div>
      <div class="list-item">{{ item.deviceDriver }}</div>
    </div>
    <pagination
      :total="total"
      layout="total,prev,pager,next"
      :page.sync="listQuery.pageIndex"
      :limit.sync="listQuery.pageSize"
      @pagination="getpaginationList"
    />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import { getLoginLogList } from "@/api/accountcenter";
export default {
  name: "LoginLog",
  components: { Pagination },
  data() {
    return {
      listData: [],
      total: 0,
      listQuery: {
        pageIndex: 1,
        pageSize: 8,
      },
    };
  },
  mounted() {
    this._getLoginLogList();
  },
  methods: {
    getpaginationList() {
      this._getLoginLogList();
    },
    _getLoginLogList() {
      getLoginLogList({ ...this.listQuery })
        .then((res) => {
          const {
            data: { data, totalCount },
          } = res;
          this.listData = [...data];
          this.total = totalCount;
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.component-container {
  width: 1040px;
  height: 650px;
  background-color: #ffffff;
  padding-left: 20px;
  padding-right: 20px;
  .title-table,
  .list-box {
    display: flex;
    border-bottom: 1px solid #eeeeee;
    .tab-item,
    .list-item {
      height: 60px;
      flex: 1;
      line-height: 60px;
      text-align: left;
      font-size: 18px;
      color: #333333;
    }
    .list-item {
      padding-left: 3px;
      font-size: 14px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/accountcenter/components/loginlog.vue